import React, { useEffect, useRef, useState } from "react";
import "../HomeWork/HomeWork.css";
// this component css comes from hwMangement/HomeWorkMain.css this css also use in homeMain compennt
import "./PreRead.css";
import SubjBoxProps from "../PreRead/Subj_Box/SubjBoxProps";
import { Popup } from "semantic-ui-react";
import FilterBox from "../PreRead/Filter_Box/FilterBox";
import Pending from "./Pending/Pending";
import Completed from "./Completed/Completed";
import PendingSubDetails from "./Pending/PendingSubDetails";
import CompletedSubDetails from "./Completed/CompletedSubDetails";
import SortedBy from "./Filter_Box/SortedBy";
import PRTour from "../../SidebarHeader/Header/PRTour";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
// import Pending from './Pending/Pending';
// import Completed from './Completed/Completed';

// useEffect(() => {
//   const pendingBox = async () => {
//     try {
//       let response = await axios.get(`homework/preRead/getById/${preReadId}`);

//       response &&
//         setHomeMain((prev) => ({ ...prev, preReadData: response.data.data }));
//       setIsGettingData(false);
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   pendingBox();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, []);

// const handleRemovePdfVivwer = () => {
//   setPedingSubDetail({
//     ...pedingSubDetail,
//     pdfView: false,
//     attachment: null,
//   });
// };

// const timeHelper = (a) => {
//   const dateObj = new Date(a);
//   const day = dateObj.getUTCDate();
//   const month = dateObj.getUTCMonth() + 1;
//   const year = dateObj.getUTCFullYear();
//   const hours = dateObj.getUTCHours();
//   const minutes = dateObj.getUTCMinutes();
//   const seconds = dateObj.getUTCSeconds();
//   const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//   return outputDateString;
// };

// const handleMarkComplete = async () => {
//   try {
//     let res = await axios.post(
//       `/homework/preReadId/${homeMain?.preReadData?.id}/studentPreRead/updateStatus/studentId/${userId}`,
//       {
//         status: "completed",
//       }
//     );
//     res && window.location.reload();
//   } catch (error) {
//     console.log(error);
//   }
// };

export default function PreReadMain({ type }) {
  const [homeMain, setHomeMain] = useState({
    subMenu: "pending",
    preReadData: null,
    PreReadSubDetail: false,
    PreReadSubDetailCompleted: false,
  });
  const popupRef = useRef(null);
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] =
    useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isSortPop, setIsSortPop] = useState(false);

  const toggleFilterPopup = () => {
    // setIsPopupOpen(!isPopupOpen);
    setIsPopupOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(false);
      }
    };

    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const togglePopup = () => {
    setIsSortPop(!isSortPop);
  };


  useEffect(() => {
    // Check if the popup has been shown before
    const hasShownPopup = localStorage.getItem("hasShownPopupPR");
    if (!hasShownPopup) {
      // Show the steps if it hasn't been shown before
      setHomeScreenWalkThroughPopup(true);
      // Set the flag in localStorage to indicate the popup has been shown
      localStorage.setItem("hasShownPopupPR", "true");
    }
  }, []);
  const [steps, setSteps] = useState([
    {
      element: ".FoterDetailContainer",
      intro: `
        <h3>Parent Features Bottom Pane</h3>
        <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Homework' parent is selected.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".homeWork",
      intro: `
        <h3>Smart.Homework</h3>
        <p>Smart.Homework has 4 features (as shown in left most pane):
       </p>
       <ol>
          <li>Homework</li>
          <li>Pre-Read</li>
          <li>Activity</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPaneHWM",
      intro: `
        <h3>Features Group Left Pane
        Smart.Homework has 3 features as shown:</h3>
        <ol>
        <li>Homework</li>
        <li>Pre-Read</li>
        <li>Activity</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".pr",
      intro: `
        <h3>Pre-Read</h3>
        <p>Currently 'Pre-Read' feature is selected, Let's navigate through this feature</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },

    {
      element: ".subWisePR ",
      intro: `
        <h3>Subject Wise Pre Read</h3>
        <p>You can see subject wise pre read count for 'pending' and 'completed'</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".CardsPR  ",
      intro: `
        <h3>Cards Section</h3>
        <p>You can open pre reads from this section.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".pendingPR",
      intro: `
        <h3>Pending</h3>
        <p>In this tab you will find Pre reads which needs to be submitted by you.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".completedPR",
      intro: `
        <h3>Completed</h3>
        <p>You will find your submitted pre reads which are reviewed by teacher.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },

    {
      element: ".filterPR",
      intro: `
        <h3>Filter</h3>
        <p>Using filter button you can filter items by subject time and date wise.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".sortByPR",
      intro: `
        <h3>Sort By</h3>
        <p>Using Sort by Button you can sort items in ascending or descending based on date.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".prifilePic",
      intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done",
      intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ]);
  const onExit = () => {
    setStepsEnabled(false);
  };
  // const [ispopupopen, setIsPopupOpen] = useState(false);
  // 
  const [rotation, setRotation] = useState(0);


  const rotateImage = () => {
    setRotation((rotation) => rotation + 180);
  };

  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    sortBy: -1,
    limit: 10,
    page: 1,
  });

  return (
    <>
      {!homeMain.PreReadSubDetail && !homeMain.PreReadSubDetailCompleted && (
        <div className="h-100 relative">
          <Steps
            enabled={stepsEnabled}
            steps={steps}
            initialStep={initialStep}
            onExit={onExit}
          />
          <div className="pending_completed_container1 ">
            <div className="text-2xl font-semibold text-blue-950">Subject-wise Pre-read</div>
            <div className="subjectBoxContainer mt-3 subWisePR">
              <SubjBoxProps />
            </div>

            <div className="homeWorkSubContainer">
              <div className="d-flex ">
                <div className="d-flex mt-3 col-2 p-0 HomeWorkSubPartsMenuTotal">
                  <div
                    className={
                      homeMain.subMenu === "pending"
                        ? "HomeWorkSubPartsMenuActive pendingPR"
                        : "HomeWorkSubPartsMenu pendingPR"
                    }
                    onClick={() =>
                      setHomeMain({ ...homeMain, subMenu: "pending" })
                    }
                  >
                    Pending
                  </div>

                  <div
                    // className='HomeWorkSubPartsMenu d-flex justify-content-center'
                    className={
                      homeMain.subMenu === "Completed"
                        ? "HomeWorkSubPartsMenuActive d-flex justify-content-center completedPR"
                        : "HomeWorkSubPartsMenu d-flex justify-content-center completedPR"
                    }
                    onClick={() =>
                      setHomeMain({ ...homeMain, subMenu: "Completed" })
                    }
                  >
                    Completed
                  </div>
                </div>
                <div className="col-1"></div>
                <div className="d-flex gap-4 align-items-center justify-content-end col-8 horizontalLine p-0 ">
                  <div className="mb-3 filterPR">
                    <div
                      className="col-md-12 gap-2 filter_box"
                      onClick={toggleFilterPopup}
                    >
                      <img
                        className="filter_icon"
                        src="/HwImg/filter Icon.svg"
                        alt="icon"
                      />
                      <span>Filter</span>
                    </div>
                    {/* <Popup
                      on="click"
                      className="popUpFilter_ass"
                      open={isPopupOpen}
                      onClose={togglePopup}
                      onOpen={togglePopup}
                      trigger={

                      }
                      content={

                      }
                      position="bottom center"
                    /> */}
                  </div>
                  <div
                    className="d-flex gap-2 align-items-center  mb-3 sortByPR"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      togglePopup()
                      rotateImage()
                    }}
                  >
                    <div className="sortby">Sort by</div>
                    <div>
                      <img
                        src="/HwImg/DownArrowSort.png"
                        alt=""
                        style={{ transform: `rotate(${rotation}deg)` }}
                      ></img>
                    </div>
                  </div>
                  {/* <Popup
                    on="click"
                    className="popUpFilter_ass"
                    trigger={


                    }
                    content={ }
                    position="bottom center"
                  /> */}
                </div>
              </div>
            </div>
          </div>
          <div className="pending_completed_container2 mt-4 orange-scrollBar"
            style={{ maxHeight: "80vh", overflowY: "scroll" }}
          >
            {homeMain.subMenu === "pending" && (
              <Pending
                setHomeMain={setHomeMain}
                setFilter={setFilter}
                filter={filter}
              />
            )}
            {homeMain.subMenu === "Completed" && (
              <Completed
                setHomeMain={setHomeMain}
                setFilter={setFilter}
                filter={filter}
              />
            )}
            {homeScreenWalkThroughPopup && (
              <PRTour
                setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
                setStepsEnabled={setStepsEnabled}
              />
            )}
            {
              isPopupOpen && (
                <div ref={popupRef}>
                  <FilterBox
                    setFilter={setFilter}
                    filter={filter}
                    toggleFilterPopup={toggleFilterPopup}
                    type={type}
                  />
                </div>
              )
            }
            {
              isSortPop && (
                <SortedBy filter={filter} type={type} setFilter={setFilter} togglePopup={togglePopup} />
              )
            }
          </div>
        </div>
      )}
      {/* {homeMain.PreReadSubDetail && (
        <PendingSubDetails setHomeMain={setHomeMain} homeMain={homeMain} />
      )} */}
      {/* {homeMain.PreReadSubDetailCompleted && (
        <CompletedSubDetails setHomeMain={setHomeMain} homeMain={homeMain} />
      )} */}
    </>
  );
}
